import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        type: 'pc',  //判断手机端还是电脑端
        userInfo: '',
        token: '',
        tags: [{
            name: '首页',
            path: 'home'
        }],
        nav: [],  //菜单栏
        menuShow: false, //二级菜单栏是否显示
        routerHistory: {}
    },
    getters: {
    },
    mutations: {
        setType(state, type) {
            state.type = type;
        },
        updateUserInfo(state, data) {
            state.userInfo = data;
        },
        setToken(state, data) {
            state.token = data;
        },
        addTags(state, data) {
            let hasTag = false;
            for(let i=0; i<state.tags.length; i++){
                if(state.tags[i].path == data.path) { 
                    hasTag = true;
                    if(data.params){ //动态路由
                        state.tags[i].name = data.name;
                        state.tags[i].params = data.params; 
                    }
                    if(data.query){
                        state.tags[i].query = data.query;
                    }
                    if(i > 8) {
                        let item = state.tags.splice(i, 1);
                        state.tags.splice(8,0,item[0]);
                    }
                    break;
                }
            }
            if(!hasTag && state.tags.length < 9){
                state.tags.push(data);
            }else if(!hasTag && state.tags.length >= 9){
                state.tags.splice(8,0,data);
            }
        },
        delTags(state, path) {
            for(let i=0; i<state.tags.length; i++) {
                if(state.tags[i].path == path) {
                    state.tags.splice(i, 1);
                    break;
                }
            }
        },
        setNav(state, data) {
            state.nav = data;
        },
        setMenu(state, v) {
            state.menuShow = v;
        },
        setRouter(state, r) {
            state.routerHistory = r;
        }
    }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js